export default {
  errors: {
    cannotBeBlank: "Este campo no puede quedar vacío",
    required: "Se requiere este campo",
    somethingWentWrong: "Algo salió mal. Inténtalo de nuevo más tarde.",
  },
  logs: {
    time: "Tiempo",
    username: "Nombre de usuario",
    role: "Función",
    terminalID: "ID del terminal",
    moduleAccessed: "Módulo accedido",
    typeOfAccess: "Tipo de acceso",
    activityLogDetails: "Detalles del registro de actividades",
    userId: "ID del usuario",
    lastLogin: "Último inicio de sesión",
    geoAccPoint: "Punto de acceso geográfico",
    ipAdd: "Dirección IP ",
    filesAccessed: "Archivos accedidos",
    funAccessed: "Función accedida",
    webUrl: "URL de página web",
    unsuccAtmp: "Intentos de inicio de sesión sin éxito",
    view: "Vista",
    membershipType: "Tipo de membresía",
  },


  validation: {
    exporterRequired: "El campo Exportador es obligatorio",
    importerRequired: "El campo Importador es obligatorio",
    portOfOriginRequired: "El campo Puerto de Origen es obligatorio",
    containerSizeNumber: "El campo Tamaño del Contenedor debe ser un número",
    containerCapacityNumber: "El campo Capacidad del Contenedor debe ser un número",
  },

}